// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2iNw5","row":"ProcedureTreatmentSummary_row__3vXCx"};